import React, { useEffect, useState } from "react";
import { useCurrency } from '../../components/CurrencyContext';
import { useFilter } from '../../components/Filter/ArtworkFilterContext';

//Cards
import ValuationSummaryCard from '../Valuations/ValuationCard';
import './ValuationCards.css';
import { PortfolioValuationSummary, convertPortfolioToBaseCurrency }  from "../../models/Valuation";

//Support Safe Api Calls
import { useUser } from '../../components/UserContext';
import { useApiClient } from "../../components/useApiClient";

import type { ArtworkFilterList } from "../../models/Artwork";

export type PortfolioValuationProps =  {
        clientId: number;
        portfolioId?: number | null;
        baseCurrency: string;
        conversionRates: Record<string, number>;
    };

const PortfolioValuation: React.FC<PortfolioValuationProps> = ({clientId, portfolioId, baseCurrency,conversionRates }) => {
    const { activeClientId, getAccessToken } = useUser();
    const { get, postJson } = useApiClient();
    const { currency } = useCurrency();
    const { filterParams, filteredArtworks, artworks, hasActiveFilters } = useFilter();

    const [portfolioData, setPortfolioData] = useState<PortfolioValuationSummary | null>(null);


    useEffect(() => {

        const fetchPortfolioData = async () => {

            const accessToken = await getAccessToken();
            if (!accessToken) return;

            const url =
                portfolioId === null || portfolioId === 0
                    ? `valuations/clientsummary/${clientId}`
                    : `valuations/portfoliosummary/${portfolioId}`;

            if (hasActiveFilters && filteredArtworks.length > 0) {
                const artworkScope: ArtworkFilterList = ({
                    artworkIds: (filteredArtworks ?? []).map(a => a.artworkId)
                });
                
                const data = await postJson<PortfolioValuationSummary>(`valuations/artworks/summary`, accessToken, artworkScope);
                if (data) {
                    setPortfolioData(data);
                }
            }
            else {
                const data = await get<PortfolioValuationSummary>(url, accessToken);

                if (data) {
                    setPortfolioData(data);
                }
            }

            
        };

        fetchPortfolioData();

    }, [clientId, portfolioId, filteredArtworks]);

    // Convert to base currency whenever baseCurrency changes
    const convertedData = portfolioData
        ? convertPortfolioToBaseCurrency(portfolioData, baseCurrency, conversionRates)
        : null;

    if (!convertedData) return <div>Loading...</div>;

    return (
        <div className = "valuation-section">
            <div className="valuation-cards">
                <ValuationSummaryCard
                    title="Acquisition Value"
                    type="acquisition"
                    lowerRange={convertedData.acquisition.totalLowerRange}
                    upperRange={convertedData.acquisition.totalUpperRange}
                    currencyCode={baseCurrency}
                    artworkCount={convertedData.acquisition.artworkCount}
                />

                <ValuationSummaryCard
                    title="Insurance Value"
                    type="insurance"
                    lowerRange={convertedData.insurance.totalLowerRange}
                    upperRange={convertedData.insurance.totalUpperRange}
                    currencyCode={baseCurrency}
                    artworkCount={convertedData.insurance.artworkCount}
                />

                <ValuationSummaryCard
                    title="Market Value"
                    type="fairMarketValue"
                    lowerRange={convertedData.fairMarketValue.totalLowerRange}
                    upperRange={convertedData.fairMarketValue.totalUpperRange}
                    currencyCode={baseCurrency}
                    artworkCount={convertedData.fairMarketValue.artworkCount}
                />
            </div>
        </div>
    );
};

export default PortfolioValuation;